import React, { useEffect } from 'react';
import { setPageTitle } from '../../utils/title';
import './Brochure.scss';
import logo from '../../assets/images/logo/devsecops_logo.png';
import awsLogo from '../../assets/images/brochure/aws_logo.png';
import awsPartnerBadge from '../../assets/images/brochure/aws_select_tier_partner.png';
import awsEcsPartner from '../../assets/images/brochure/aws_ecs_delivery_partner.png';
import fulltrustLogo from '../../assets/images/brochure/fulltrust-logo-dark.svg';

const Brochure = () => {
  useEffect(() => {
    setPageTitle('DevSecOps, Inc. - Capabilities Brochure');
  }, []);

  return (
    <div className="brochure-page">
      {/* Page 1: Main Content */}
      <div className="brochure-page__main">
        <div className="magazine-header">
          <div className="magazine-header__logo">
            <img src={logo} alt="DevSecOps, Inc. Logo" className="brochure-logo" />
          </div>
          <div className="magazine-header__title">
            <h1>DevSecOps, Inc.</h1>
            <div className="tagline">Securing Tomorrow's Innovation</div>
          </div>
        </div>

        <div className="magazine-hero">
          <h2 className="hero-title">
            Regulatory-Compliant
            <br /> Cloud and AI Security for Your SMB
          </h2>
          <div className="hero-quote">
            <blockquote>
              "Unlike traditional DevSecOps agencies, we combine deep expertise in AWS
              infrastructure, AI/ML systems, and regulatory compliance to deliver holistic security
              solutions that protect both your cloud infrastructure and AI assets while ensuring
              regulatory compliance."
            </blockquote>
          </div>
        </div>

        <div className="section-title">
          <span className="section-number">01</span>
          <h2>Core Services</h2>
        </div>

        <div className="aws-partnership">
          <div className="aws-partnership__main">
            <img src={awsLogo} alt="Amazon Web Services" className="aws-logo" />
            <div className="aws-partnership__text">
              <h3>AWS-Native Solutions</h3>
              <p>We deliver secure, scalable, and compliant cloud solutions exclusively on AWS</p>
            </div>
            <div className="aws-partnership__badges">
              <img src={awsPartnerBadge} alt="AWS Select Tier Partner" className="aws-badge" />
              <img src={awsEcsPartner} alt="AWS ECS Delivery Partner" className="aws-badge" />
            </div>
          </div>
        </div>

        <div className="compliance-standards">
          <div className="standards-grid">
            <div className="standard-badge">
              <div className="badge-text">SOC 2</div>
              <div className="badge-subtext">Type II Compliance</div>
            </div>
            <div className="standard-badge">
              <div className="badge-text">HIPAA</div>
              <div className="badge-subtext">Security+Privacy Rules</div>
            </div>
            <div className="standard-badge">
              <div className="badge-text">NIST 800-171</div>
              <div className="badge-subtext">CUI Protection</div>
            </div>
            <div className="standard-badge">
              <div className="badge-text">NIST 800-53</div>
              <div className="badge-subtext">Security Controls</div>
            </div>
            <div className="standard-badge">
              <div className="badge-text">NIST AI RMF</div>
              <div className="badge-subtext">AI Risk Management</div>
            </div>
          </div>
          <div className="standards-caption">
            Comprehensive compliance expertise across major security and AI standards
          </div>
        </div>

        <div className="services-grid">
          <div className="service-feature">
            <div className="service-feature__header">
              <h3>Regulatory-Compliant Cloud Infrastructure</h3>
              <div className="feature-line"></div>
            </div>
            <div className="service-feature__content">
              <ul>
                <li>Secure AWS infrastructure design and implementation</li>
                <li>Containerized application security on ECS and EKS</li>
                <li>Comprehensive cloud security posture management</li>
                <li>Automated compliance controls and monitoring</li>
              </ul>
            </div>
          </div>

          <div className="service-feature">
            <div className="service-feature__header">
              <h3>AI Security and Governance</h3>
              <div className="feature-line"></div>
            </div>
            <div className="service-feature__content">
              <ul>
                <li>Comprehensive model security and protection against tampering and theft</li>
                <li>End-to-end secure ML data pipelines with advanced poisoning prevention</li>
                <li>Robust MLOps security practices and deployment protection</li>
                <li>AI risk management and continuous compliance monitoring</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Page 2: Supplementary Content */}
      <div className="brochure-page__supplementary">
        <div className="magazine-additional">
          <div className="section-title">
            <span className="section-number">02</span>
            <h2>Additional Expertise</h2>
          </div>

          <div className="expertise-grid">
            <div className="service-feature">
              <div className="service-feature__header">
                <h3>Expert FinOps Solutions</h3>
                <div className="feature-line"></div>
              </div>
              <div className="service-feature__content">
                <p>Optimize your cloud costs while maintaining security and performance</p>
              </div>
            </div>

            <div className="service-feature">
              <div className="service-feature__header">
                <h3>IT Compliance Programs</h3>
                <div className="feature-line"></div>
              </div>
              <div className="service-feature__content">
                <p>Comprehensive guidance for successful compliance certification</p>
              </div>
            </div>

            <div className="service-feature">
              <div className="service-feature__header">
                <h3>Secure AI Implementation</h3>
                <div className="feature-line"></div>
              </div>
              <div className="service-feature__content">
                <p>Deploy LLMs and custom models with robust security guardrails</p>
              </div>
            </div>
          </div>
        </div>

        <div className="magazine-contact">
          <div className="section-title">
            <span className="section-number">03</span>
            <h2>Connect With Us</h2>
          </div>
          <div className="contact-grid">
            <div className="service-feature">
              <div className="service-feature__header">
                <h3>Website</h3>
                <div className="feature-line"></div>
              </div>
              <div className="service-feature__content">
                <p>www.devsecopsinc.io</p>
              </div>
            </div>
            <div className="service-feature">
              <div className="service-feature__header">
                <h3>Phone & WhatsApp</h3>
                <div className="feature-line"></div>
              </div>
              <div className="service-feature__content">
                <p>+1 (305) 215-8383</p>
              </div>
            </div>
            <div className="service-feature">
              <div className="service-feature__header">
                <h3>Email</h3>
                <div className="feature-line"></div>
              </div>
              <div className="service-feature__content">
                <p>constantine@devsecopsinc.io</p>
              </div>
            </div>
          </div>
        </div>

        <div className="fulltrust-banner">
          <div className="fulltrust-banner__content">
            <div className="fulltrust-banner__logo">
              <img src={fulltrustLogo} alt="FullTrust Logo" />
              <span className="website-url">https://fulltrust.io</span>
            </div>
            <div className="fulltrust-banner__text">
              <h3>Accelerate Your Compliance Journey with FullTrust</h3>
              <p>
                Our compliance automation platform helps organizations achieve and maintain
                regulatory compliance faster and more efficiently than ever before.
              </p>
              <div className="fulltrust-features">
                <span className="feature">Automated Controls</span>
                <span className="feature">Real-time Monitoring</span>
                <span className="feature">Continuous Compliance</span>
                <span className="feature">Audit-Ready Reports</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Brochure;
